import React from "react";
import useBreakPoinst from "@hooks/useBreakPoinst";
import {
  PaymentSuccessContainer,
  Title,
  Description,
  InfoBox,
  StyledButton,
  Badge,
  BadgeText,
  FailPaymentIcon,
  ReTryIcon,
  MsoolIcon,
} from "./styles";
import { useNavigate, useParams } from "react-router-dom";

const GuestPortalPaymentFail = () => {
  const { isPhone } = useBreakPoinst();
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <PaymentSuccessContainer $isPhone={isPhone}>
      {/* svg iCon */}
      <FailPaymentIcon $isPhone={isPhone} />
      <Title $isPhone={isPhone}>فشل الدفع</Title>

      <Description $isPhone={isPhone}>
        حدثت مشكلة أثناء معالجة الدفع. يرجى التحقق من تفاصيل بطاقتك والمحاولة
        مرة أخرى
      </Description>
      <InfoBox $isPhone={isPhone}>
        كانت هناك مشكلة في معالجة دفعتك. قد يكون ذلك بسبب عدم كفاية الأموال، أو
        تفاصيل بطاقة غير صحيحة، أو مشكلة مؤقتة مع مزود الدفع.
      </InfoBox>
      <StyledButton
        onClick={() => {
          navigate(`/guest/summary-page/${id}`);
        }}
        $isPhone={isPhone}
      >
        حاول مرة أخرى
        <ReTryIcon $isPhone={isPhone} />
      </StyledButton>
      <Badge $isPhone={isPhone}>
        <BadgeText $isPhone={isPhone}>مشغل بواسطة مسؤول</BadgeText>
        <MsoolIcon $isPhone={isPhone} />
      </Badge>
    </PaymentSuccessContainer>
  );
};

export default GuestPortalPaymentFail;
